<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      style="background-color: white"
      :width="iframeWidth"
      no-gutters
    >
      <span v-html="styledIframe"/>

      <v-btn @click="dialog = false">
        Sluiten
      </v-btn>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    iframe: null,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    iframeWidth() {
      return this.video.iframe_width ? this.video.iframe_width : 750;
    },
    styledIframe() {
      const iframeHtml = this.video.iframe;
      return iframeHtml.replace('<iframe', '<iframe style="width: 100%; height: 750px"');
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.iframe = this.video.iframe;
      } else {
        this.iframe = null;
      }
    },
  },
  created() {
    this.iframe = this.video.iframe;
  },
};
</script>
